module.exports = __webpack_public_path__ + "img/pathfinder_side.3a52790f.png";